import React from 'react';

import { ListItem } from 'components/ListItem';
import * as Types from 'types';
import { formatArtworkPrice } from 'services/stringFormating';

type Props = {
  edition: Types.EditionWithArtwork;
};

export const EditionStats: React.FC<Props> = ({ edition }) => {
  const purchasePrice = edition.certificate.purchasePrice
    ? formatArtworkPrice(edition.certificate.purchasePrice)
    : 'N/A';

  const currentPrice = formatArtworkPrice(edition.artwork.price);

  return (
    <ul className='edition-details__stats'>
      <ListItem title='Purchase Price' value={purchasePrice} />
      <ListItem title='Current Price' value={currentPrice ? currentPrice : 'N/A'} />
      <ListItem title='Total Editions' value={String(edition.artwork.totalEditions)} />
    </ul>
  );
};
